import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { GateWayService } from 'src/app/services/gateway.service';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import {Observable, of} from 'rxjs';
import * as featureActions from '../../index';
import {catchError, combineLatest, map, mergeMap, switchMap, withLatestFrom} from 'rxjs/operators';
import { GateWayDeviceActions, GateWayDeviceActionTypes } from '../actions/gateway-device.actions';
import { UpdateInfoModel } from '../../updateInfo/update-info.model';
import { updateInfoType } from '../../../shareModel';
import {PreferenceService} from '../../../services/preference.service';

@Injectable()
export class GateWayDeviceEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private getwayService = inject(GateWayService);
  private preferenceService = inject(PreferenceService);

  constructor() {}

  ReadGatewayDeviceList$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayDeviceActionTypes.ReadGatewayDeviceList),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const param = {
        otp: user.otp,
        GatewayList: action.payload.GatewayList
      }
      return this.getwayService.ReadGatewayDeviceList(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [
                    new featureActions.UpsertGatewayDeviceList(res.msg.body)];
          } else {
            return [new featureActions.ReadGatewayDeviceListFail(res.errmsg.body)];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.ReadGatewayDeviceListFail()];
        })
      );
    })
  ));
  AddDeviceToCloud$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayDeviceActionTypes.AddDeviceToCloud),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.AddDeviceToCloud
      };
      const param = { ...action.payload, otp: user.otp };
      return this.getwayService.AddDeviceToCloud(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.ResultAddDeviceToCloud(res.msg.body), new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.result, msg: 'Add Device To Cloud Success' })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, msg: 'Add Device To Cloud Fail', errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: error })];
        })
      );
    })
  ));
}
